<template>
<div>
  <h5>Imagens do sistema</h5>
  <div
    class="row text-center"
    style="padding: 20px 30px 20px 30px;"
  >
    <p>Imagens devem ter fundo transparente. Formatos: .png ou .svg</p>
    <div class="col-md-4">
      <p class="category">Logotipo no termo de lâmpada</p>
      <img
        id="img_imgTermLamp"
        v-if="config.hasOwnProperty('_attachments') && config._attachments.hasOwnProperty('imgTermLamp')"
        :src="urlImages.imgTermLamp"
      />
      <br>
      <button
        :disabled="loadingImages"
        class="btn btn-fill"
        @click="$refs['imgTermLamp'].click()"
      >Selecionar imagem
      </button>
      <input
        id="imgTermLamp"
        @change="getFiles"
        ref="imgTermLamp"
        style="display: none"
        type="file"
        accept="image/*"
      />
    </div>

    <div class="col-md-4">
      <p class="category">Logotipo no termo de comodato</p>
      <img
        id="img_imgTermLending"
        v-if="config.hasOwnProperty('_attachments') && config._attachments.hasOwnProperty('imgTermLending')"
        :src="urlImages.imgTermLending"
      />
      <br>
      <button
        :disabled="loadingImages"
        class="btn btn-fill"
        @click="$refs['imgTermLending'].click()"
      >Selecionar imagem
      </button>
      <input
        id="imgTermLending"
        @change="getFiles"
        ref="imgTermLending"
        style="display: none"
        type="file"
        accept="image/*"
      />
    </div>

    <div class="col-md-4">
      <p class="category">Logotipo no protocolo de entrega</p>
      <img
        id="img_imgTermDelivery"
        v-if="config.hasOwnProperty('_attachments') && config._attachments.hasOwnProperty('imgTermDelivery')"
        :src="urlImages.imgTermDelivery"
      />
      <br>
      <button
        @click="$refs['imgTermDelivery'].click()"
        :disabled="loadingImages"
        class="btn btn-fill"
      >Selecionar imagem
      </button>
      <input
        id="imgTermDelivery"
        @change="getFiles"
        ref="imgTermDelivery"
        style="display: none"
        type="file"
        accept="image/*"
      />
    </div>

    <div
      class="col-md-12"
      style="margin-top: 50px;"
    >
      <p class="category">Logotipos no apresentador</p>
      <div class="row">
        <div class="col-md-6">
          <img
            src="/static/img/project-form/presenter-orientation-img.svg"
            alt="Image left"
          />
          <img
            id="img_imgPresenterLeft"
            v-if="config.hasOwnProperty('_attachments') && config._attachments.hasOwnProperty('imgPresenterLeft')"
            :src="urlImages.imgPresenterLeft"
          />
          <br>
          <button
            @click="$refs['imgPresenterLeft'].click()"
            :disabled="loadingImages"
            class="btn btn-fill"
          >Selecionar imagem
          </button>
          <input
            id="imgPresenterLeft"
            @change="getFiles"
            ref="imgPresenterLeft"
            style="display: none"
            type="file"
            accept="image/*"
          />
        </div>
        <div class="col-md-6">
          <img
            id="img_imgPresenterRight"
            v-if="config.hasOwnProperty('_attachments') && config._attachments.hasOwnProperty('imgPresenterRight')"
            :src="urlImages.imgPresenterRight"
          />
          <img
            src="/static/img/project-form/presenter-orientation-img.svg"
            alt="Image left"
            style="transform: rotateY(180deg)"
          />
          <br>
          <button
            @click="$refs['imgPresenterRight'].click()"
            :disabled="loadingImages"
            class="btn btn-fill"
          >
            Selecionar imagem
          </button>
          <input
            id="imgPresenterRight"
            @change="getFiles"
            ref="imgPresenterRight"
            style="display: none"
            type="file"
            accept="image/*"
          />
        </div>
      </div>
    </div>
  </div>
  <canvas
    id="canvasPlace"
    style="display: none;"
  ></canvas>
</div>
</template>

<script>
import { filesService } from '../../services/filesService'
import { mapActions, mapGetters } from 'vuex'
import swal from 'sweetalert2'

export default {
  name: 'project-images',

  data () {
    return {
      loadingImages: false
    }
  },

  computed: {
    ...mapGetters(['config']),

    urlImages: {
      get: function () {
        return this.$store.state.project.urlImages
      }
    }
  },

  methods: {
    ...mapActions('project', ['uploadFileProject', 'fetchOne', 'getImagesProject']),

    async getFiles (event) {
      try {
        this.loadingImages = true
        const imgName = event.target.id
        const type = event.target.files[0].type
        const file = await this.handleFile(event, type)
        await this.uploadFileProject({ id: 'config', mimeType: type, name: `${imgName}`, file })
        this.loadingImages = false
        swal({
          titleText: 'Imagem salva com sucesso',
          confirmButtonText: 'OK'
        })
        this.fetchOne('config')
        document.getElementById(`img_${imgName}`).src = document.getElementById(`img_${imgName}`).src + '?' + (new Date()).getMilliseconds()
      } catch (e) {
        console.log('err', e)
      }
    },

    handleFile (event, type) {
      return new Promise(resolve => {
        if (type === 'image/svg+xml') {
          resolve(filesService.handleBlob(event, type))
          return
        }
        resolve(filesService.handleImage(event)
          .then(result => {
            return result[0].blob
          })
        )
      })
    }
  },

  mounted () {
    this.getImagesProject()
  }
}
</script>

<style scoped>
  p {
    margin-top: 10px;
  }

  input, button {
    margin-top: 10px;
  }
  img {
    max-height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Project/ProjectImages.vue